import React from 'react';
import { Button } from '@accure/ui';
import { BotMessageSquare } from 'lucide-react';
import { useBoolean } from 'usehooks-ts';

import { FullPageContent } from '@/components/layout/full-page-content';
import { SlideOver } from '@/components/ui/slide-over';
import { Tooltip } from '@/components/ui/tooltip';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

import { AiChatbox } from './ai-chatbox';

export type AiChatboxShellProps = {};
export function AiChatboxShell({
  children,
}: React.PropsWithChildren<AiChatboxShellProps>) {
  const featureFlag = useFeatureFlag();
  const showChatbox = useBoolean();

  if (!featureFlag('ai')) {
    return <>{children}</>;
  }

  return (
    <FullPageContent>
      <FullPageContent scrollable>{children}</FullPageContent>
      <div className="fixed bottom-8 right-12" data-testid="ai-chatbot">
        <Tooltip content="Open AI Chatbox" delay position="left">
          <Button
            className="size-12 bg-primary-500 hover:bg-primary-400"
            onClick={showChatbox.setTrue}
          >
            <BotMessageSquare className="size-8" />
          </Button>
        </Tooltip>
      </div>
      <SlideOver
        size="3xl"
        hasDropShadow={false}
        open={showChatbox.value}
        onClose={showChatbox.setFalse}
        unmount={false}
      >
        <AiChatbox />
      </SlideOver>
    </FullPageContent>
  );
}
